query blastRecipients($teamId: ID!, $search:String!) {
  blastRecipients(teamId:$teamId, search:$search) {
    ...on GradeLevel {
      __typename
      id
      name
      team {id}
      studentCount
      students {
        __typename
        id
        first
        last
        homeNumbers {
          id
          number
          label
          formattedNumber
          homeLanguage {
            id
            language
            name
          }
        }
      }
    }
    ...on Student {
      __typename
      id
      first
      last
      team {id}
      gradeLevel {
        id
        name
      }
      homeNumbers {
        id
        number
        label
        formattedNumber
        homeLanguage {
          id
          language
          name
        }
      }
    }
    ...on Group {
      __typename
      id
      name
      team {id}
      teacher {
        id
        last
      }
      studentCount
      students {
        __typename
        id
        first
        last
        homeNumbers {
          id
          number
          label
          formattedNumber
          homeLanguage {
            id
            language
            name
          }
        }
      }
    }
  }
}
